module.exports = __webpack_public_path__ + "static/linus-torvalds-c795b420bdfe57c29e355611f14fd11c.jpg";